import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoteAutocompleteComponent } from './remote-autocomplete.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { RemoteAutocompleteOptionComponent } from './remote-autocomplete-option/remote-autocomplete-option.component';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  declarations: [
    RemoteAutocompleteComponent,
    RemoteAutocompleteOptionComponent,
  ],
  imports: [CommonModule, InputModule, CheckboxModule, TooltipModule, SpinnerModule],
  exports: [RemoteAutocompleteComponent, RemoteAutocompleteOptionComponent],
})
export class RemoteAutocompleteModule {}
